import { translate } from '@fiverr-private/i18n-react';

export const getTitle = ({ showTranslatedUGC, localizedTitle, translatedTitle, title, gigTitleKey }) => {
    if (showTranslatedUGC && localizedTitle) {
        return localizedTitle;
    }

    if (showTranslatedUGC && translatedTitle) {
        return translatedTitle;
    }

    return translate(gigTitleKey, { params: { title } });
};
